import { render, staticRenderFns } from "./AddTravelManager.vue?vue&type=template&id=61646aba&scoped=true"
import script from "./AddTravelManager.vue?vue&type=script&lang=ts"
export * from "./AddTravelManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61646aba",
  null
  
)

export default component.exports